export default __webpack_public_path__ + "static/media/10.af0cc66a.png";